module.exports = __webpack_public_path__ + "static/media/logo_stiftung_footer.392fedc4.jpg";